import { inject, Pipe, PipeTransform } from '@angular/core';

import { COMMON_ENVIRONMENT } from '../tokens/environment';
import { buildMainClientUrl } from '../utils/main-client-url.util';

@Pipe({
	name: 'mainClientUrl',
	pure: true,
	standalone: true,
})
export class MainClientUrlPipe implements PipeTransform {
	private readonly clientEnvironment = inject(COMMON_ENVIRONMENT);

	transform(paths: string[]): string {
		return buildMainClientUrl(paths, this.clientEnvironment.mainClient.url);
	}
}
